// extracted by mini-css-extract-plugin
module.exports =  {"carouselWrapper":"gjEMkj","carousel":"rXuzrx","swiperRoot":"Ysedrh","swiperWrapper":"Qu153V","swiperSlide":"ZcLLWS","showArrowsOnHover":"l3UA1A","arrow":"DIFPWv"};